import { TFunction } from 'i18next';
import { CatPricingAnalysisRow } from './types';
import { ValidationError } from 'components/ui/excel-table/types';

export const validateCatPricingAnalysisRow = (
  row: CatPricingAnalysisRow,
  rowIndex: number,
  t: TFunction
): ValidationError<CatPricingAnalysisRow>[] => {
  const errors: ValidationError<CatPricingAnalysisRow>[] = [];
  // Cat Multiplier validation
  if (row.catMultiplier === undefined || Number(row.catMultiplier) < 0) {
    errors.push({
      field: 'catMultiplier',
      rowIndex,
      message: t('catPricingAnalysis.validation.catMultiplierInvalid'),
    });
  }

  // Cat Rate validation
  if (
    row.catRate === undefined ||
    Number(row.catRate) < 0 ||
    Number(row.catRate) > 100
  ) {
    errors.push({
      field: 'catRate',
      rowIndex,
      message: t('catPricingAnalysis.validation.catRateInvalid'),
    });
  }
  return errors;
};
